export enum AttachedFileType {
  SupplierInvoiceAttachment = 'SupplierInvoiceAttachment',
  Directory = 'Directory',
  File = 'File',
  Root = 'Root',
}

export enum AttachedFileStatus {
  Normal = 'Normal',
  Deleted = 'Deleted'
}

export interface AttachedFileDto {
  id: string;
  parentId?: string;
  created: Date;
  createdBy: UserDto;
  fileName: string;
  status: AttachedFileStatus;
  fakturaId: number | null;
  type: AttachedFileType;
  size?: number;
  isPermissionInherited: boolean;
  isPrivate: AttachedFilePrivateType;
}

export interface AttachedFileWithPermissionsDto extends AttachedFileDto {
  permissions: AttachedFilePermissionDto;
}

export interface AttachedFilePermissionDto {
  items: AttachedFilePermissionItemDto[];
}

export interface UserGroupWithDetailsDto extends UserGroupDto {
  users: UserDto[];
}
export interface UserGroupDto {
  id: number;
  name: string;
}

export interface AttachedFilePermissionItemDto {
  user: UserDto;
  userGroup: UserGroupDto;
  type: AttachedFilePermissionType;
}

export enum AttachedFileSortColumn {
  Id = 'Id',
  FileName = 'FileName',
  Size = 'Size'
}
export interface SupplierInvoiceAttachedFilesDeleteResponse {
  nrOfAttachedFiles: number;
}

export interface SupplierInvoiceAttachedFilesPostSingleResponse extends SupplierInvoiceAttachedFilesDeleteResponse {
  value: AttachedFileDto;
}

export enum AttachedFilePermissionType {
  ReadOnly = 'ReadOnly',
  ReadWrite = 'ReadWrite',
  Owner = 'Owner'
}

export enum AttachedFilePrivateType
{
    None = 'None',
    ReadWrite = 'ReadWrite',
    WriteOnly = 'WriteOnly',
}

export interface PermissionsItem {
  isPermissionsInherited: boolean | null;
  groupId: number | null;
  filePermissionType: AttachedFilePermissionType | null;
}
export interface AttachedFilesPostSingleRequest {
  parentId: string | null;
  permissions?: PermissionsItem | null;
}

export enum SessionUpdateCmdType {
  UppdateraAntalBifogadeFiler = "UppdateraAntalBifogadeFiler",
  KonteringSynk = "KonteringSynk"
}

export interface SessionUpdateCmd {
  cmdType: SessionUpdateCmdType;
  fakturaId?: number | null;
  konteringSynkSmetaUt?: boolean | null;
}

export interface GenericSearchWrapper<T> {
  totalItems: number;
  items: T[];
}

export interface GenericSearchWrapperWithSortOrder<T, TSortOrder> extends GenericSearchWrapper<T> {
  sortColumn: TSortOrder;
  sortAscending: boolean;
  metaData: PaginationInfoMetadata;
}

export interface PaginationInfoMetadata
{
  pageSize: number;
  page: number;
  totalHits: number;
  noPages: number;
}


export interface UserGroup {
  id: number;
  clientId: number;
  name: string;
  users: UserDto[];
}

export interface UserDto {
  id: number;
  userName: string;
  fullName: string;
  email: string;
  uniqueId: string;
}

// This one is shared with Contract Module, so it is serialized as integers for now.
export enum PermissionType {
  Admin = 0,
  User = 1,
  WebUser = 2,
  Attestant = 3,
  SearchInvoices = 4,
  ChangeInvoiceInformation = 5,
  ChangeKontering = 6,
  BytaAttestkedja = 7,
  AktivaFakturor = 8,
  Suppliers = 9,
  Kontoplan = 10,
  Attestkedjemall = 11,
  Kostnadsstallen = 12,
  Projekt = 13,
  Valutor = 14,
  Bokforing = 15,
  Betalningar = 16,
  Contracts = 17,
  FilArkiv = 18,
}

export interface ClientLocal {
  gid: string;
  clientId: number;
  name: string;
  orgNr: string;
  status: KlientStatus;
  moduleSupplierInvoices: boolean;
  moduleReports: boolean;
  moduleContracts: boolean;
  userPermissions: { [key: number]: UserPermission; };
  accounts: Accounts;
}
export interface UserPermission {
  isInstanceAdmin: any;
  user: UserDto;
  permissions: PermissionType[];
}

export interface Accounts {
  levSkuldsKonto: number | null;
  momsKonto: number | null;
  kostnadsKonto: number | null;
}

export enum KlientStatus {
  Normal = 78, // 'N',
  Testforetag = 84, // 'T',
  Inaktiv = 73 // 'I'
}

export interface BefattningDto {
  id: number;
  user: UserDto;
  permissions: PermissionType[];
  fromDate?: Date | null;
  toDate?: Date | null;
  restrictedSearchSettings?: RestrictedSearchSettingsDto | null;
}

export enum AccessLevel {
  Normal = 'Normal',
  Förhöjd = 'Förhöjd'
}
export interface RestrictedSearchSettingsDto {
  supplierList: string[];
  accountList: string[];
  projectList: string[];
  costCenterList: string[];
  object3List: string[];
  onlyFinallyAttested: boolean;
  accessLevel: AccessLevel | null;
}
